// ----------------------------------------------------------------------------
// Section: Product Slider
// ----------------------------------------------------------------------------
//
// This is a section that displays product slider items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_reviews-carousel.scss';


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const REVIEWS_SLIDER_SELECTOR = '.carousel--reviews-slider-container';
const CAROUSEL_SELECTOR        = '.carousel--reviews-slider';
const PREV_BUTTON_SELECTOR     = '.reviews-slider-button-prev';
const NEXT_BUTTON_SELECTOR     = '.reviews-slider-button-next';
const SCROLLBAR_SELECTOR       = '.swiper-scrollbar';

// -------------------------------------
// Helpers
// -------------------------------------

const initReviewsCarousel = (productSlider) => {
    const carousel   = productSlider.querySelector(CAROUSEL_SELECTOR)
    const prevButton = productSlider.querySelector(PREV_BUTTON_SELECTOR);
    const nextButton = productSlider.querySelector(NEXT_BUTTON_SELECTOR);
    const scrollbar  = productSlider.querySelector(SCROLLBAR_SELECTOR);

    const swiper = new Swiper(carousel, {
        modules: [Navigation, Scrollbar, A11y, Keyboard],
        slidesPerView: 1.1,
        spaceBetween: 15,
        centerInsufficientSlides: true,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
        grabCursor: true,

        breakpoints: {
            680: {
                slidesPerView: 1.6,
                spaceBetween: 25,
            },
            1024: {
                slidesPerView: 2.2,
                spaceBetween: 25,
            }
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        scrollbar: {
            el: scrollbar,
            draggable: true,
        }
    });

    swiper.slides.forEach(function(slide, index) {
        const slideLink = slide.querySelector('a');

        slideLink.addEventListener('focus', function(e) {
            swiper.slideTo(index);
        })
    });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const productSliders = document.querySelectorAll(REVIEWS_SLIDER_SELECTOR);

    productSliders.forEach((productSlider) => {
        initReviewsCarousel(productSlider);
    });
});